import axios from "axios";
import { FormDateField, FormTimeField } from "../../components/form/date";
import {
  FormDropDown,
  FormMultiSelectDropDown,
} from "../../components/form/dropdown";
import { FormFileUploadField } from "../../components/form/file";
import { FormImageField } from "../../components/form/image";
import { FormMultiFileUploadField } from "../../components/form/multi-file";
import { FormMultiImageField } from "../../components/form/multi-image";
import FormTextField from "../../components/form/text";
import { FormTextAreaField } from "../../components/form/text-area";
import { url } from "../../config";
import MainLayout from "../../layout";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { uiTypes } from "../../utils/types";
import { FormDropDownDynamic } from "../../components/form/dynamic-dropdown";
import { useEffect, useState } from "react";
import {
  FormCheckboxField,
  FormToggleSwitch,
} from "../../components/form/checkbox";
import FormJsonEditor from "../../components/form/json";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import FormTextArrayField from "../../components/form/text-array";
import { FormMultiImageVideoField } from "../../components/form/multi-image-video";
import { FormLocationPickerField } from "../../components/map/map-selector";
import { FormDocumentField } from "../../components/form/document-field";

const Editpage = ({ model }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const viewId = id;
  const { tableName, columns, references } = model;
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({});

  const columnHeadings = () => {
    var array = [];
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (column.ui?.edit === null || column.ui.edit === true) {
        array.push(column.name);
      }
    }
    return array;
  };
  const headings = columnHeadings();

  useEffect(() => {
    if (viewId) {
      axios
        .post(`${url}/model/${tableName}/read`, { id: viewId ?? "" })
        .then((response) => {
          var resData = { ...response.data.data };

          if (references != null) {
            for (let index = 0; index < references.length; index++) {
              const reference = references[index];
              if (Array.isArray(resData[reference.tableName])) {
                var arrayValues = [];
                for (let j = 0; j < resData[reference.tableName].length; j++) {
                  const element = resData[reference.tableName][j];
                  arrayValues.push(element[reference.displayKey]);
                }
                resData[reference.tableName] = arrayValues.toString();
              } else if (
                resData[references.tableName] &&
                typeof resData[references.tableName] === "object"
              ) {
                if (
                  resData[references.tableName][reference.displayKey] != null
                ) {
                  resData[reference.tableName] =
                    resData[references.tableName][reference.displayKey];
                } else {
                  resData[reference.tableName] = "";
                }
              } else {
                resData[reference.tableName] = "";
              }
            }
          }
          console.log("resData", resData);

          var values = columns.reduce((data, column) => {
            if (column.ui?.edit == null || column.ui.edit === true) {
              data[column?.name] = column?.name ? resData[column?.name] : "";
            }
            return data;
          }, {});

          setInitialValues({ ...values });
          setLoading(false);
        })
        .catch((error) => {
          console.error("API Error:", error);
          setLoading(false);
        });
    }
  }, [tableName, viewId, columns, references]);

  // const getValidationType = (validations = []) => {
  //   let validationSchema;

  //   if (validations.includes(validatorTypes.string))
  //     validationSchema = Yup.string();
  //   else if (validations.includes(validatorTypes.email))
  //     validationSchema = Yup.string().email("Invalid email");
  //   else if (validations.includes(validatorTypes.uuid))
  //     validationSchema = Yup.string().uuid("Invalid UUID");
  //   else if (validations.includes(validatorTypes.number))
  //     validationSchema = Yup.number();
  //   else if (validations.includes(validatorTypes.bool))
  //     validationSchema = Yup.boolean();
  //   else if (validations.includes(validatorTypes.date))
  //     validationSchema = Yup.date();
  //   else if (validations.includes(validatorTypes.array))
  //     validationSchema = Yup.array();
  //   else validationSchema = Yup.string();

  //   if (validations.includes(validatorTypes.required)) {
  //     validationSchema = validationSchema.required("This field is required");
  //   } else if (validations.includes(validatorTypes.optional)) {
  //     validationSchema = validationSchema.notRequired();
  //   }

  //   return validationSchema;
  // };

  const validationSchema = Yup
    .object
    // model.columns.reduce((data, column) => {
    //   if (column.ui?.create == null || column.ui.create === true) {
    //     data[column.name] = getValidationType(column.ui?.validation);
    //   }
    //   return data;
    // }, {})
    ();

  const handleSubmit = (values) => {
    console.log("Submitted values:", values);
    axios
      .post(`${url}/model/${tableName}/edit`, {
        where: {
          id: id,
        },
        values: {
          ...values,
        },
      })
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        navigate(`/${tableName}/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const enumToOptions = (enumValues = []) =>
    enumValues.map((val) => ({
      label: val.charAt(0).toUpperCase() + val.slice(1),
      value: val,
    }));

  return (
    <MainLayout>
      <section className="h-full overflow-auto md:px-3">
        {loading ? (
          <div className="h-full flex justify-center items-center">
            <div>
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent mx-2"></div>
              <p className="mt-2 text-sm text-gray-500">Loading...</p>
            </div>
          </div>
        ) : (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => {
                const saveDisable =
                  JSON.stringify(initialValues) === JSON.stringify(values);

                return (
                  <Form>
                    <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-[5000]">
                      <h2 className="text-xl font-semibold capitalize">
                        {formatUnderscoreToSpace(tableName)} - Edit
                      </h2>
                      <div className="flex gap-3 items-center">
                        <button
                          onClick={() => navigate(`/${tableName}/list`)}
                          type="button"
                          className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                        >
                          Cancel
                        </button>
                        <button
                          disabled={saveDisable}
                          type="submit"
                          className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded disabled:opacity-45"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                    <section className="w-full max-w-[40rem]">
                      {headings.map((heading) => {
                        const column = columns.find(
                          (value) => value.name === heading
                        );

                        if (
                          (column.ui?.edit === null ||
                            column?.ui?.edit === true) &&
                          column?.ui?.type === uiTypes?.CHECKBOX
                        ) {
                          return (
                            <FormCheckboxField name={heading} label={heading} />
                          );
                        }

                        if (
                          (column.ui?.edit === null ||
                            column?.ui?.edit === true) &&
                          column?.ui?.type === uiTypes?.NUMBER
                        ) {
                          return (
                            <FormTextField
                              name={heading}
                              label={heading}
                              placeholder={`Enter ${heading}`}
                              type="number"
                            />
                          );
                        }
                        if (
                          (column.ui?.create === null ||
                            column?.ui?.create === true) &&
                          column?.ui?.type === uiTypes?.TEXT_ARRAY
                        ) {
                          return (
                            <FormTextArrayField
                              name={heading}
                              label={heading}
                            />
                          );
                        }

                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes?.TIME
                        ) {
                          return (
                            <FormTimeField name={heading} label={heading} />
                          );
                        }
                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes?.DATE
                        ) {
                          return (
                            <FormDateField
                              name={heading}
                              label={heading}
                              value={values?.[heading]}
                            />
                          );
                        }
                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes?.DATE_TIME
                        ) {
                          return (
                            <FormDateField
                              name={heading}
                              label={heading}
                              type="datetime-local"
                            />
                          );
                        }

                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes?.TEXT_AREA
                        ) {
                          return (
                            <FormTextAreaField
                              name={heading}
                              label={heading}
                              placeholder={`Enter ${heading}`}
                            />
                          );
                        }

                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes?.DROPDOWN
                        ) {
                          if (!column?.enumValues) {
                            var reference = references.find(
                              (value) => value.foreignKey === heading
                            );
                            return (
                              <FormDropDownDynamic
                                name={heading}
                                label={heading}
                                reference={reference}
                                placeholder="Select"
                              />
                            );
                          }

                          return (
                            <FormDropDown
                              name={heading}
                              label={heading}
                              options={enumToOptions(column?.enumValues)}
                              value={enumToOptions(column?.enumValues)?.find(
                                (item) => item?.value === values?.[heading]
                              )}
                            />
                          );
                        }
                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes?.DROPDOWN_MULTISELECT
                        ) {
                          return (
                            <FormMultiSelectDropDown
                              name={heading}
                              label={heading}
                              options={enumToOptions(column?.enumValues)}
                              value={enumToOptions(column?.enumValues)?.find(
                                (item) => item?.value === values?.[heading]
                              )}
                            />
                          );
                        }

                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes.IMAGE
                        ) {
                          return (
                            <FormImageField name={heading} label={heading} />
                          );
                        }
                        if (
                          column?.ui?.edit &&
                          column?.isArray &&
                          column?.ui?.type === uiTypes.MULTI_IMAGE
                        ) {
                          return (
                            <FormMultiImageField
                              name={heading}
                              label={heading}
                            />
                          );
                        }

                        if (
                          (column.ui?.create === null ||
                            column?.ui?.create === true) &&
                          column?.ui?.type === uiTypes.DOCUMENT
                        ) {
                          return (
                            <FormDocumentField name={heading} label={heading} />
                          );
                        }

                        if (
                          (column.ui?.create === null ||
                            column?.ui?.create === true) &&
                          column?.isArray &&
                          column?.ui?.type === uiTypes.MULTI_IMAGE_VIDEO
                        ) {
                          return (
                            <FormMultiImageVideoField
                              name={heading}
                              label={heading}
                            />
                          );
                        }

                        if (
                          column?.ui?.edit &&
                          column?.ui?.type === uiTypes.FILE
                        ) {
                          return (
                            <FormFileUploadField
                              name={heading}
                              label={heading}
                              accept=".pdf,.doc,.docx"
                            />
                          );
                        }
                        if (
                          column?.ui?.edit &&
                          column?.isArray &&
                          column?.ui?.type === uiTypes.MULTI_FILE
                        ) {
                          return (
                            <FormMultiFileUploadField
                              name={heading}
                              label={heading}
                              accept=".pdf,.doc,.docx,.jpg,.png"
                            />
                          );
                        }
                        if (
                          (column.ui?.edit === null ||
                            column?.ui?.edit === true) &&
                          column?.ui?.type === uiTypes?.JSON
                        ) {
                          return (
                            <FormJsonEditor
                              name={heading}
                              label={heading}
                              value={values?.[heading]}
                            />
                          );
                        }
                        if (
                          (column.ui?.edit === null ||
                            column?.ui?.edit === true) &&
                          column?.ui?.type === uiTypes?.SWITCH
                        ) {
                          return (
                            <FormToggleSwitch
                              name={heading}
                              label={heading}
                              value={values?.[heading]}
                            />
                          );
                        }

                        if (
                          (column.ui?.edit === null ||
                            column?.ui?.edit === true) &&
                          column?.ui?.type === uiTypes?.MAP
                        ) {
                          return (
                            <FormLocationPickerField
                              name={heading}
                              label={heading}
                              value={values?.[heading]}
                            />
                          );
                        }

                        return (
                          <>
                            {column?.ui?.edit && (
                              <FormTextField
                                label={heading}
                                name={heading}
                                placeholder={`Enter ${heading}`}
                              />
                            )}
                          </>
                        );
                      })}
                    </section>
                  </Form>
                );
              }}
            </Formik>
          </>
        )}
      </section>
    </MainLayout>
  );
};

export default Editpage;
